import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import { Helmet } from "react-helmet";
import Toast from "../../components/Toast";
import SweetAlert from "react-bootstrap-sweetalert";
// import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faUserCog,
  faCog,
  faSignOutAlt,
  faPencilAlt,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import LoadingScreen from "../../components/LoadingScreen";
import Footer from "../../components/Footer";
import moment from "moment";
require("moment/locale/id");

class HomeBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      token: localStorage.getItem("Authorization"),
      hasBrief: false,
      dataBrief: [],
      btype: [],
      alert: null,
      messages: null,
      isReady: 0,
    };
    this.hideMessage = this.hideMessage.bind(this);
    this.confirmLogout = this.confirmLogout.bind(this);
    this.showOptionBrief = this.showOptionBrief.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/customer/whois`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let msg = response.data.success;
        if (msg === true) {
          this.checkHasBrief();
          let progress1 = this.state.isReady + 30;
          this.setState({
            user: response.data.user,
            isReady: progress1,
          });

          var welcoming = localStorage.getItem("Welcoming");
          if (welcoming === "1") {
            setTimeout(() => this.showMessage(), 1000);
          }
        } else {
          this.props.history.push("/login");
        }
      });
  }

  checkHasBrief() {
    axios
      .get(`${window.localhost}/customer/hasbrief`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let progress2 = this.state.isReady + 20;
        this.setState({ isReady: progress2 });
        if (response.data.success === true) {
          this.setState({
            hasBrief: true,
            dataBrief: response.data.data,
          });
        } else {
          this.setState({
            hasBrief: false,
            dataBrief: response.data.data,
          });
        }
        this.getBtype();
      });
  }

  getBtype() {
    axios
      .get(`${window.localhost}/customer/btype`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let progress3 = this.state.isReady + 50;
        if (response.data.success === true) {
          this.setState({
            btype: response.data.btype,
            isReady: progress3,
          });
        }
      });
  }

  showOptionBrief() {
    const getAlert = () => (
      <SweetAlert
        showCloseButton
        btnSize="sm"
        confirmBtnText="Close"
        title="Pilih Jenis Brief"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
        confirmBtnBsStyle="btn-outline-light text-dark d-none"
        customClass={"w-md-30 w-100"}
      >
        <div className="list-group mt-3">
          {this.state.btype.map((btp, i) => (
            <Link
              to={`/create/${btp.slug}`}
              className={`${
                btp.status === "published" ? "" : "d-none"
              } list-group-item list-group-item-action text-start py-4 fw-bold`}
            >
              {btp.label.toUpperCase()}
            </Link>
          ))}
        </div>
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  showMessage() {
    const toast = () => (
      <Toast
        message={`Selamat Datang ${this.state.user.fullname}`}
        hide={this.hideMessage}
        name="CreatifaStudio"
      />
    );

    this.setState({
      messages: toast(),
    });
    localStorage.removeItem("Welcoming");
    setTimeout(() => this.hideMessage(), 5000);
  }

  hideMessage() {
    this.setState({
      messages: null,
    });
  }

  confirmLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleLogout() {
    axios
      .get(`${window.localhost}/customer/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.props.history.push("/login");
        }
      });
  }

  confirmDeleteBrief(briefname, briefid, btypeid) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Delete"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleDeleteBrief(briefid, btypeid)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin menghapus {briefname}?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleDeleteBrief(briefid, btypeid) {
    axios
      .delete(`${window.localhost}/customer/brief/${btypeid}/${briefid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          const getAlert = () => (
            <SweetAlert
              success
              title="Brief Berhasil Dihapus!"
              onConfirm={() => this.onSuccessDelete()}
              timeout={2000}
              confirmBtnText="Oke"
              confirmBtnBsStyle="warning"
            ></SweetAlert>
          );
          this.setState({
            alert: getAlert(),
          });
        }
      });
  }

  onSuccessDelete() {
    this.checkHasBrief();
    this.hideAlert();
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    const { user } = this.state;

    if (this.state.isReady < 100) {
      return <LoadingScreen />;
    } else {
      const navmenu = () => {
        return (
          <div className="dropdown">
            <button
              className="btn text-danger d-flex align-items-center dropdown-toggle"
              aria-current="page"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="me-2 d-md-flex d-none">{user.fullname}</span>
              <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <Link className="dropdown-item" to={`/info-pengguna`}>
                  <FontAwesomeIcon icon={faUserCog} /> Info Pengguna
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button className="dropdown-item" onClick={this.confirmLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                </button>
              </li>
            </ul>
          </div>
        );
      };

      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Dashboard - Creatifa Brief App</title>
            <meta
              name="description"
              content="Brief ini untuk membantu kami dalam membuat desain logo Anda. Mohon luangkan waktu untuk mengisi dengan jawaban se-objektif mungkin. Semakin Anda menuliskan gambaran usaha Anda dengan jelas, semakin kami dapat memahami desain logo seperti apa yang Anda butuhkan"
            />
          </Helmet>
          <Header menu={navmenu()} destination={`/`} />
          <div className="container wrapper-sm wrapper mb-5">
            <div className="card container p-3 mb-4">
              <div className="row">
                <h2 className="fw-bold">
                  <span className="cf-header px-2">Brief Dashboard</span>
                </h2>
              </div>
              <hr />
              <div className="row row-cols-md-6 row-cols-2 g-4">
                <div className="col">
                  <button
                    onClick={this.showOptionBrief}
                    className="btn btn-red text-white text-center shadow w-100 h-100 mb-3"
                  >
                    <FontAwesomeIcon icon={faPencilAlt} className="fs-5" /> Buat
                    Brief
                  </button>
                </div>
              </div>
            </div>

            <div className="card container p-3 mb-4">
              {this.state.hasBrief ? (
                <div className="table-responsive">
                  <h2>
                    <span className="cf-header fw-bold px-2">Brief List</span>
                  </h2>
                  <hr />
                  <table className="table table-hover">
                    <thead>
                      <tr className="bg-dark text-light border border-1">
                        <th scope="col" className="text-center">
                          Jenis
                        </th>
                        <th scope="col" className="ps-3">
                          Nama
                        </th>
                        <th scope="col">Tanggal Kirim</th>
                        <th scope="col" className="ps-3"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.dataBrief.map((data, i) => (
                        <tr key={i} className="border-1">
                          <td
                            className={`align-middle text-white fw-bold text-center bg-red`}
                          >
                            {data.btype.label.toUpperCase()}
                          </td>
                          <td className="align-middle ps-3 fw-bold">
                            {data.answer}
                          </td>
                          <td className="align-middle fw-bold">
                            {moment(
                              data.created_at,
                              "YYYY-MM-DD hh:mm:ss"
                            ).format("DD MMMM YYYY")}
                          </td>
                          <td className="align-middle">
                            <div className="dropstart">
                              <button
                                className="btn btn-light border-1 float-end shadow-sm"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <FontAwesomeIcon icon={faEllipsisV} />
                              </button>
                              <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    to={`/view/${data.btype.slug}/${data.brief_id}`}
                                  >
                                    View
                                  </Link>
                                </li>
                                <li>
                                  <button
                                    onClick={() =>
                                      this.confirmDeleteBrief(
                                        data.answer,
                                        data.brief_id,
                                        data.btype_id
                                      )
                                    }
                                    className="dropdown-item"
                                  >
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="row">
                  <p>Anda belum membuat brief.</p>
                </div>
              )}
            </div>
          </div>

          {this.state.messages}
          {this.state.alert}
          <Footer className="fixed-bottom" />
        </div>
      );
    }
  }
}

export default HomeBrief;
